import { FAQCategory } from 'modules/support/components/FAQTiles/FAQTiles';
import QuestionPage from 'modules/support/components/QuestionPage/QuestionPage';
import CategorySubpage from 'modules/support/screens/CategorySubpage/CategorySubpage';
import VideoResources from 'modules/support/screens/VideoResources/VideoResources';
import AgreementTransferFAQ from 'modules/support/screens/AgreementTransferFAQ/AgreementTransferFAQ';
import AgreementTransferStatus from 'modules/support/screens/AgreementTransferStatus/AgreementTransferStatus';
import pages from 'pages';
import React, { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router';
import LoadingLogo from 'shared/components/Modal/LoadingLogo';
import { FeatureFlagGuard } from 'guards/FeatureFlagGuard';
import { FlagKey } from 'api/types';

const SupportScreen = lazy(() => import('modules/support/screens/Support'));

export const Support: RouteObject[] = [
  {
    path: `${pages.SUPPORT}/*`,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingLogo />}>
            <SupportScreen />
          </Suspense>
        ),
      },
      {
        path: pages.ACCOUNT_SUPPORT,
        element: <CategorySubpage category={FAQCategory.ACCOUNT} />,
      },
      {
        path: pages.BILL_PAYMENTS,
        element: <CategorySubpage category={FAQCategory.PAYING_BILL} />,
      },
      {
        path: pages.PAYMENT_CALCULATIONS,
        element: <CategorySubpage category={FAQCategory.PAYMENT_CALCULATIONS} />,
      },
      {
        path: pages.REAMORTIZATION,
        element: <CategorySubpage category={FAQCategory.REAMORTIZATION} />,
      },
      {
        path: pages.SYSTEM_CHANGES,
        element: <CategorySubpage category={FAQCategory.SYSTEM_CHANGES} />,
      },
      {
        path: pages.SYSTEM_PERFORMANCE,
        element: <CategorySubpage category={FAQCategory.SYSTEM_PERFORMANCE} />,
      },
      { path: pages.VIDEO_RESOURCES, element: <VideoResources /> },
      {
        path: pages.AGREEMENT_TRANSFER,
        element: (
          <FeatureFlagGuard flagKey={FlagKey.homeownerTransferSelfService}>
            <AgreementTransferFAQ />
          </FeatureFlagGuard>
        ),
      },
      {
        path: pages.AGREEMENT_TRANSFER_STATUS,
        element: (
          <FeatureFlagGuard flagKey={FlagKey.homeownerTransferSelfService}>
            <AgreementTransferStatus />
          </FeatureFlagGuard>
        ),
      },
      { path: pages.FAQ_QUESTION, element: <QuestionPage /> },
    ],
  },
];

export default Support;
